// File: src/pages/student/MajorWikiPage.jsx
import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/avt.png'; 
const IconArrowLeft = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>;

// --- DỮ LIỆU NGÀNH HỌC SIÊU CHI TIẾT (FULL 12 NHÓM) ---
const MAJOR_DATA = [

    {

        id: "ECO", group: "Kinh Tế - Quản Trị", icon: "💰",

        desc: "Dòng tiền, thị trường và vận hành doanh nghiệp.",

        majors: [

            { name: "Quản trị kinh doanh", salary: "10 - 50M", hot: true, subjects: ["A00", "A01", "D01"], desc: "Học cách vận hành một doanh nghiệp từ A-Z. Ngành học 'đa năng' nhất, đào tạo tư duy lãnh đạo.", jobs: ["CEO", "Quản lý dự án", "Chuyên viên tư vấn"], skills: ["Lãnh đạo", "Chiến lược", "Giao tiếp"], suitableMBTIs: ["ENTJ", "ESTJ", "ENFJ", "ESTP"] },

            { name: "Marketing & Digital", salary: "10 - 45M", hot: true, subjects: ["A01", "D01", "C00"], desc: "Nghệ thuật tiếp cận khách hàng, xây dựng thương hiệu và sáng tạo nội dung số.", jobs: ["Brand Manager", "Content Creator", "Digital Marketer"], skills: ["Sáng tạo", "Nhạy bén", "Phân tích"], suitableMBTIs: ["ENFP", "ESFP", "ENTP", "ENFJ"] },

            { name: "Kinh doanh quốc tế", salary: "15 - 55M", hot: true, subjects: ["A01", "D01"], desc: "Giao thương xuyên biên giới, xuất nhập khẩu và đàm phán đa văn hóa.", jobs: ["Chuyên viên XNK", "Đàm phán viên"], skills: ["Ngoại ngữ", "Tư duy mở"], suitableMBTIs: ["ENTJ", "ENTP", "ESTP"] },

            { name: "Logistics & Chuỗi cung ứng", salary: "12 - 40M", hot: true, subjects: ["A00", "A01"], desc: "Quản lý dòng chảy hàng hóa tối ưu nhất từ nơi sản xuất đến tay người dùng.", jobs: ["Quản lý kho", "Điều phối vận tải"], skills: ["Sắp xếp", "Chịu áp lực"], suitableMBTIs: ["ISTJ", "ESTJ", "INTJ"] },

            { name: "Tài chính - Ngân hàng", salary: "15 - 60M", hot: false, subjects: ["A00", "A01"], desc: "Quản lý tiền tệ, đầu tư, tín dụng và thị trường chứng khoán.", jobs: ["Chuyên viên tín dụng", "Nhà đầu tư"], skills: ["Toán học", "Cẩn trọng"], suitableMBTIs: ["ISTJ", "INTJ", "ENTJ"] },

            { name: "Kế toán - Kiểm toán", salary: "10 - 35M", hot: false, subjects: ["A00", "D01"], desc: "Ghi chép, kiểm tra sổ sách và báo cáo tình hình tài chính minh bạch.", jobs: ["Kế toán trưởng", "Kiểm toán viên"], skills: ["Tỉ mỉ", "Nguyên tắc"], suitableMBTIs: ["ISTJ", "ISFJ", "ESTJ"] },

            { name: "Bất động sản", salary: "10 - 100M", hot: true, subjects: ["A00", "D01"], desc: "Đầu tư, định giá và kinh doanh tài sản đất đai, nhà ở.", jobs: ["Môi giới BĐS", "Định giá tài sản"], skills: ["Giao tiếp", "Thuyết phục"], suitableMBTIs: ["ESTP", "ESFP", "ENTJ"] },

            { name: "Quản trị nhân sự (HR)", salary: "10 - 30M", hot: false, subjects: ["C00", "D01"], desc: "Tuyển dụng, đào tạo và xây dựng văn hóa công ty.", jobs: ["HR Manager", "Headhunter"], skills: ["Thấu hiểu", "Kết nối"], suitableMBTIs: ["ESFJ", "ENFJ", "ISFJ"] }

        ]

    },

    {

        id: "TECH", group: "Công Nghệ - Kỹ Thuật", icon: "💻",

        desc: "Xu hướng số hóa toàn cầu.",

        majors: [

            { name: "Công nghệ thông tin", salary: "15 - 60M", hot: true, subjects: ["A00", "A01"], desc: "Nền tảng của kỷ nguyên số: Phần cứng, mạng và hệ thống.", jobs: ["SysAdmin", "Developer", "IT Support"], skills: ["Logic", "Tự học"], suitableMBTIs: ["INTP", "INTJ", "ISTP"] },

            { name: "Kỹ thuật phần mềm", salary: "15 - 70M", hot: true, subjects: ["A00", "A01"], desc: "Chuyên sâu về quy trình làm phần mềm: Web, App, System.", jobs: ["Frontend Dev", "Backend Dev", "Tester"], skills: ["Coding", "Hệ thống"], suitableMBTIs: ["INTJ", "INTP", "ISTJ"] },

            { name: "Trí tuệ nhân tạo (AI)", salary: "25 - 120M", hot: true, subjects: ["A00", "A01"], desc: "Dạy máy tính suy nghĩ, xử lý dữ liệu lớn và học máy.", jobs: ["AI Engineer", "Data Scientist"], skills: ["Toán cao cấp", "Python"], suitableMBTIs: ["INTP", "INTJ", "ENTP"] },

            { name: "An toàn thông tin", salary: "20 - 80M", hot: true, subjects: ["A00", "A01"], desc: "Bảo vệ hệ thống khỏi Hacker, bảo mật dữ liệu.", jobs: ["Pentester", "Security Analyst"], skills: ["Phản biện", "Đạo đức"], suitableMBTIs: ["ISTP", "INTJ", "INTP"] },

            { name: "IoT & Tự động hóa", salary: "15 - 50M", hot: true, subjects: ["A00", "A01"], desc: "Kết nối vật lý và kỹ thuật số. Smart home, Robot.", jobs: ["Kỹ sư nhúng", "Kỹ sư Robot"], skills: ["Phần cứng", "Vật lý"], suitableMBTIs: ["ISTP", "INTP"] },

            { name: "Khoa học dữ liệu", salary: "20 - 90M", hot: true, subjects: ["A00", "A01"], desc: "Khai thác dữ liệu để tìm Insight kinh doanh.", jobs: ["Data Analyst", "Data Engineer"], skills: ["SQL", "Thống kê"], suitableMBTIs: ["INTJ", "INTP", "ISTJ"] }

        ]

    },

    {

        id: "MED", group: "Y - Dược - Sức Khỏe", icon: "🩺",

        desc: "Chăm sóc và bảo vệ sức khỏe con người.",

        majors: [

            { name: "Y đa khoa", salary: "20 - 100M", hot: true, subjects: ["B00"], desc: "Bác sĩ khám chữa bệnh toàn diện. Học 6 năm.", jobs: ["Bác sĩ"], skills: ["Y đức", "Chịu áp lực"], suitableMBTIs: ["ISFJ", "INFJ", "ISTJ"] },

            { name: "Dược học", salary: "12 - 40M", hot: true, subjects: ["A00", "B00"], desc: "Nghiên cứu, sản xuất và kinh doanh thuốc.", jobs: ["Dược sĩ", "Trình dược viên"], skills: ["Cẩn thận", "Hóa học"], suitableMBTIs: ["ISTJ", "ISFJ", "INTP"] },

            { name: "Răng - Hàm - Mặt", salary: "30 - 150M", hot: true, subjects: ["B00"], desc: "Bác sĩ chuyên khoa răng miệng và thẩm mỹ.", jobs: ["Nha sĩ"], skills: ["Khéo tay", "Thẩm mỹ"], suitableMBTIs: ["ISTJ", "ISFJ", "ISTP"] },

            { name: "Điều dưỡng", salary: "10 - 25M", hot: false, subjects: ["B00"], desc: "Chăm sóc bệnh nhân, hỗ trợ bác sĩ điều trị.", jobs: ["Điều dưỡng viên"], skills: ["Tận tâm", "Kiên nhẫn"], suitableMBTIs: ["ISFJ", "ESFJ", "ISFP"] },

            { name: "Tâm lý học", salary: "10 - 35M", hot: true, subjects: ["C00", "D01"], desc: "Nghiên cứu hành vi, cảm xúc và trị liệu tinh thần.", jobs: ["Chuyên gia tâm lý", "HR"], skills: ["Lắng nghe", "Thấu cảm"], suitableMBTIs: ["INFJ", "INFP", "ENFJ"] }

        ]

    },

    {

        id: "EDU", group: "Giáo Dục - Xã Hội", icon: "📖",

        desc: "Trồng người và nghiên cứu xã hội.",

        majors: [

            { name: "Sư phạm", salary: "8 - 25M", hot: false, subjects: ["D01", "A00", "C00"], desc: "Giảng dạy và đào tạo thế hệ tương lai.", jobs: ["Giáo viên", "Giảng viên"], skills: ["Truyền đạt", "Yêu trẻ"], suitableMBTIs: ["ENFJ", "ESFJ", "INFJ"] },

            { name: "Ngôn ngữ Anh/Trung", salary: "10 - 35M", hot: true, subjects: ["D01", "D04"], desc: "Cầu nối văn hóa và kinh tế toàn cầu.", jobs: ["Biên phiên dịch", "Giáo viên"], skills: ["Ngôn ngữ", "Giao tiếp"], suitableMBTIs: ["ENFP", "INFJ", "ESFP"] },

            { name: "Xã hội học", salary: "8 - 20M", hot: false, subjects: ["C00", "D01"], desc: "Nghiên cứu cấu trúc và hành vi xã hội.", jobs: ["Nghiên cứu viên", "Công tác xã hội"], skills: ["Phản biện", "Viết lách"], suitableMBTIs: ["INFP", "INFJ", "ENTP"] }

        ]

    },

    {

        id: "LAW", group: "Luật & Hành Chính", icon: "⚖️",

        desc: "Bảo vệ công lý và trật tự.",

        majors: [

            { name: "Luật Kinh tế", salary: "15 - 50M", hot: true, subjects: ["A00", "A01"], desc: "Pháp lý trong kinh doanh và thương mại.", jobs: ["Pháp chế", "Luật sư"], skills: ["Logic", "Chặt chẽ"], suitableMBTIs: ["ESTJ", "ENTJ", "ISTJ"] },

            { name: "Luật học", salary: "10 - 40M", hot: false, subjects: ["C00", "D01"], desc: "Luật dân sự, hình sự, tố tụng.", jobs: ["Luật sư", "Thẩm phán"], skills: ["Hùng biện", "Trí nhớ"], suitableMBTIs: ["ENTP", "ESTP", "ENTJ"] },

            { name: "Quan hệ quốc tế", salary: "12 - 40M", hot: true, subjects: ["D01", "A01"], desc: "Ngoại giao và chính trị thế giới.", jobs: ["Nhà ngoại giao", "Điều phối viên"], skills: ["Ngoại ngữ", "Đàm phán"], suitableMBTIs: ["ENFJ", "ENTJ", "ENFP"] }

        ]

    },

    {

        id: "ART", group: "Nghệ Thuật - Sáng Tạo", icon: "🎨",

        desc: "Thế giới của cái đẹp và trí tưởng tượng.",

        majors: [

            { name: "Thiết kế đồ họa", salary: "10 - 35M", hot: true, subjects: ["H00", "V00"], desc: "Sáng tạo hình ảnh thương hiệu, quảng cáo.", jobs: ["Graphic Designer", "Art Director"], skills: ["Thẩm mỹ", "Adobe"], suitableMBTIs: ["ISFP", "INFP", "ENFP"] },

            { name: "Thiết kế thời trang", salary: "10 - 50M", hot: false, subjects: ["H00", "V00"], desc: "Tạo ra xu hướng ăn mặc và phong cách.", jobs: ["Fashion Designer", "Stylist"], skills: ["Gu thẩm mỹ", "Vẽ tay"], suitableMBTIs: ["ISFP", "ESFP", "ENFP"] },

            { name: "Truyền thông đa phương tiện", salary: "12 - 35M", hot: true, subjects: ["C00", "D01"], desc: "Sản xuất nội dung số: Video, Ảnh, Web.", jobs: ["Producer", "Video Editor"], skills: ["Công nghệ", "Nghệ thuật"], suitableMBTIs: ["ENFP", "ENTP", "ESFP"] }

        ]

    },

    {

        id: "SERVICE", group: "Du Lịch - Khách Sạn", icon: "✈️",

        desc: "Ngành công nghiệp không khói.",

        majors: [

            { name: "Quản trị Khách sạn", salary: "10 - 50M", hot: false, subjects: ["C00", "D01"], desc: "Vận hành hệ thống lưu trú, nghỉ dưỡng.", jobs: ["Quản lý khách sạn", "F&B Manager"], skills: ["Giao tiếp", "Xử lý tình huống"], suitableMBTIs: ["ESFJ", "ESTP", "ESFP"] },

            { name: "Hướng dẫn viên du lịch", salary: "10 - 30M", hot: false, subjects: ["C00", "D01"], desc: "Dẫn tour, giới thiệu văn hóa.", jobs: ["Tour Guide"], skills: ["Sức khỏe", "Hoạt ngôn"], suitableMBTIs: ["ESFP", "ESTP", "ENFP"] },

            { name: "Tiếp viên hàng không", salary: "20 - 45M", hot: true, subjects: ["D01"], desc: "Phục vụ hành khách trên các chuyến bay.", jobs: ["Tiếp viên"], skills: ["Ngoại hình", "Tiếng Anh"], suitableMBTIs: ["ESFJ", "ISFP", "ESFP"] }

        ]

    },

    {

        id: "AGRI", group: "Nông - Lâm - Ngư", icon: "🌱",

        desc: "Phát triển bền vững, công nghệ sinh học.",

        majors: [

            { name: "Nông nghiệp công nghệ cao", salary: "10 - 30M", hot: true, subjects: ["B00", "A00"], desc: "Ứng dụng công nghệ vào trồng trọt.", jobs: ["Kỹ sư nông nghiệp"], skills: ["Yêu thiên nhiên", "Công nghệ"], suitableMBTIs: ["ISTP", "ISFP", "INTJ"] },

            { name: "Thú y", salary: "10 - 40M", hot: true, subjects: ["B00"], desc: "Bác sĩ cho động vật.", jobs: ["Bác sĩ thú y"], skills: ["Yêu động vật", "Khéo léo"], suitableMBTIs: ["ISFP", "ISFJ", "INFP"] },

            { name: "Công nghệ thực phẩm", salary: "10 - 25M", hot: false, subjects: ["A00", "B00"], desc: "Chế biến và kiểm định chất lượng thực phẩm.", jobs: ["QA/QC", "R&D"], skills: ["Hóa học", "Vị giác"], suitableMBTIs: ["ISTJ", "ISFJ", "ISTP"] }

        ]

    },

    {

        id: "SPORT", group: "Thể Thao - Lifestyle", icon: "⚽",

        desc: "Sức khỏe và phong cách sống.",

        majors: [

            { name: "Huấn luyện viên thể hình", salary: "15 - 50M", hot: true, subjects: ["T00"], desc: "Giúp mọi người cải thiện vóc dáng.", jobs: ["PT", "Coach"], skills: ["Ngoại hình", "Động viên"], suitableMBTIs: ["ESTP", "ESFP", "ENTJ"] },

            { name: "Quản lý thể thao", salary: "10 - 30M", hot: false, subjects: ["C00", "A01"], desc: "Tổ chức sự kiện, quản lý CLB.", jobs: ["Bầu show", "Quản lý CLB"], skills: ["Tổ chức", "Kinh doanh"], suitableMBTIs: ["ESTJ", "ENTJ", "ESTP"] }

        ]

    },

    {

        id: "SKILL", group: "Kỹ Năng Nghề", icon: "🛠️",

        desc: "Vững tay nghề, sống khỏe.",

        majors: [

            { name: "Đầu bếp - Pha chế", salary: "10 - 50M", hot: true, subjects: ["Xét tuyển"], desc: "Nghệ sĩ của hương vị.", jobs: ["Bếp trưởng", "Barista"], skills: ["Vị giác", "Sáng tạo"], suitableMBTIs: ["ISFP", "ESTP", "ISTP"] },

            { name: "Kỹ thuật viên sửa chữa", salary: "10 - 25M", hot: false, subjects: ["Xét tuyển"], desc: "Sửa ô tô, điện lạnh, điện thoại.", jobs: ["Thợ kỹ thuật"], skills: ["Khéo tay", "Tỉ mỉ"], suitableMBTIs: ["ISTP", "ISTJ"] },

            { name: "Thẩm mỹ - Spa", salary: "15 - 100M", hot: true, subjects: ["Xét tuyển"], desc: "Làm đẹp cho đời.", jobs: ["KTV Spa", "Makeup Artist"], skills: ["Thẩm mỹ", "Giao tiếp"], suitableMBTIs: ["ISFP", "ESFJ", "ESFP"] }

        ]

    },

    {

        id: "FUTURE", group: "Nghề Mới & Tương Lai", icon: "🚀",

        desc: "Tiềm năng lớn trong kỷ nguyên số.",

        majors: [

            { name: "Prompt Engineer (AI)", salary: "20 - 60M", hot: true, subjects: ["A01", "D01"], desc: "Kỹ sư tối ưu hóa câu lệnh cho AI.", jobs: ["AI Trainer"], skills: ["Ngôn ngữ", "Logic"], suitableMBTIs: ["INTP", "ENTP", "INTJ"] },

            { name: "Blockchain Developer", salary: "30 - 150M", hot: true, subjects: ["A00"], desc: "Lập trình chuỗi khối và Web3.", jobs: ["Blockchain Dev"], skills: ["Mật mã học", "Coding"], suitableMBTIs: ["INTJ", "ISTP", "INTP"] },

            { name: "Sustainability Manager", salary: "20 - 50M", hot: true, subjects: ["A01", "D01"], desc: "Quản lý phát triển bền vững ESG.", jobs: ["ESG Manager"], skills: ["Tầm nhìn", "Chiến lược"], suitableMBTIs: ["INFJ", "ENFJ", "INTJ"] }

        ]

    }

];

export default function MajorWikiPage() {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeGroupId, setActiveGroupId] = useState("ALL");
    const [selectedMajor, setSelectedMajor] = useState(null);
    const [userMBTI, setUserMBTI] = useState(null); 

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    // Fetch MBTI User
    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem('skillmatch_token');
            if (!token) return;
            try {
                const res = await fetch(`${API_URL}/api/student/profile`, {
                    headers: { 'x-auth-token': token }
                });
                if (res.ok) {
                    const data = await res.json();
                    if (data.mbtiResult && data.mbtiResult.code) {
                        setUserMBTI(data.mbtiResult);
                    }
                }
            } catch (e) { console.error(e); }
        };
        fetchProfile();
    }, []);

    // Filter Logic
    const filteredData = useMemo(() => {
        return MAJOR_DATA.map(group => {
            if (activeGroupId !== "ALL" && group.id !== activeGroupId) return null;
            const matchingMajors = group.majors.filter(m => 
                m.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                group.group.toLowerCase().includes(searchTerm.toLowerCase())
            );
            return matchingMajors.length > 0 ? { ...group, majors: matchingMajors } : null;
        }).filter(Boolean);
    }, [searchTerm, activeGroupId]);

    // Check MBTI
    const checkCompatibility = (majorMBTIs) => {
        if (!userMBTI) return null;
        const userCode = userMBTI.code.split('');
        if (majorMBTIs.includes(userMBTI.code)) return "Rất phù hợp";
        
        const bestMatch = majorMBTIs.some(code => {
            let matchCount = 0;
            code.split('').forEach((char, i) => { if (char === userCode[i]) matchCount++; });
            return matchCount >= 3;
        });
        return bestMatch ? "Phù hợp" : "Cần nỗ lực thêm";
    };

    return (
        <div className="student-page-container">
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            
            <div className="top-nav">
                <button className="back-btn-modern" onClick={() => navigate('/student')}>
                    <div className="icon-circle"><IconArrowLeft /></div>
                    <span>Dashboard</span>
                </button>
            </div>

            <div className="content-wrapper animate-fade-up">
                <div className="flex justify-center mb-6">
                                                <img
                                                    src={logoImg}
                                                    alt="SkillMatch Logo"
                                                    className="h-24 w-auto object-contain drop-shadow-md hover:scale-105 transition-transform"
                                                />
                                            </div>
                
                {/* --- 1. MAIN LIST VIEW --- */}
                {!selectedMajor && (
                    <>
                        <div className="text-center mb-10 mt-6">
                            <h1 className="student-title text-4xl mb-4">
                                Từ điển <span className="highlight">Ngành Học</span> 📚
                            </h1>
                            <p className="student-subtitle max-w-2xl mx-auto">
                                Kho tàng dữ liệu về mọi ngành nghề. Tra cứu lương, khối thi và tố chất phù hợp.
                            </p>
                        </div>

                        {/* Search Bar (Pure White Style - Fixed Black Border) */}
                       <div className="bg-white p-4 rounded-full shadow-lg flex items-center gap-3 
                max-w-3xl mx-auto mb-10 sticky top-4 z-40 transition-all 
                border-0">
    <span className="material-symbols-outlined text-gray-400 pl-2">
        search
    </span>
    <input 
        type="text" 
        placeholder="Nhập tên ngành (VD: IT, Bác sĩ, Marketing...)" 
        className="w-full py-2 bg-transparent text-gray-700 font-medium text-lg 
                   placeholder-gray-400 
                   outline-none focus:outline-none focus:ring-0 
                   focus-visible:outline-none appearance-none border-0"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>
                        {/* Auto-Slide Filters (Marquee) */}
                        <div className="w-full overflow-hidden mb-8 mask-gradient">
                            <div className="flex gap-4 animate-marquee hover:pause whitespace-nowrap px-4">
                                {/* Duplicate for infinite loop */}
                                {[...MAJOR_DATA, ...MAJOR_DATA].map((g, index) => (
                                    <button 
                                        key={`${g.id}-${index}`}
                                        onClick={() => setActiveGroupId(g.id === activeGroupId ? "ALL" : g.id)}
                                        className={`px-6 py-3 rounded-full font-bold transition-all border shadow-sm flex items-center gap-2 ${
                                            activeGroupId === g.id 
                                            ? 'bg-pink-600 text-white border-pink-600 scale-105' 
                                            : 'bg-white text-gray-600 border-gray-100 hover:bg-gray-50'
                                        }`}
                                    >
                                        <span className="text-xl">{g.icon}</span> {g.group}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* List Grid */}
                        <div className="space-y-12 pb-20">
                            {filteredData.map(group => (
                                <div key={group.id} className="animate-fade-in">
                                    <div className="flex items-center gap-3 mb-6 border-b border-gray-200/50 pb-2">
                                        <span className="text-3xl">{group.icon}</span>
                                        <div>
                                            <h2 className="text-2xl font-black text-gray-800">{group.group}</h2>
                                            <p className="text-gray-500 text-sm">{group.desc}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {group.majors.map((major, idx) => (
                                            <div 
                                                key={idx} 
                                                className="bg-white hover:bg-pink-50/30 p-6 rounded-[24px] border border-white shadow-sm hover:shadow-xl transition-all cursor-pointer relative group hover:-translate-y-1 flex flex-col h-full" 
                                                onClick={() => setSelectedMajor(major)}
                                            >
                                                {major.hot && (
                                                    <span className="absolute top-4 right-4 bg-red-50 text-red-600 text-[10px] font-extrabold px-2 py-1 rounded-full uppercase tracking-wide border border-red-100 flex items-center gap-1">
                                                        🔥 HOT
                                                    </span>
                                                )}
                                                
                                                <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-pink-600 transition-colors pr-12 leading-snug">
                                                    {major.name}
                                                </h3>
                                                
                                                <p className="text-gray-500 text-sm line-clamp-2 mb-4 flex-grow leading-relaxed">
                                                    {major.desc}
                                                </p>
                                                
                                                <div className="flex flex-wrap gap-2 mb-4">
                                                    {major.subjects.slice(0, 3).map(sub => (
                                                        <span key={sub} className="text-xs font-bold px-2 py-1 bg-gray-100 text-gray-600 rounded-lg border border-gray-200">
                                                            {sub}
                                                        </span>
                                                    ))}
                                                </div>

                                                <div className="border-t border-gray-100 pt-3 flex justify-between items-center text-sm mt-auto">
                                                    <span className="text-gray-400 font-medium">Lương khởi điểm</span>
                                                    <span className="font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-lg">{major.salary}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {/* --- 2. FLOATING DETAIL MODAL (ROUNDED & CENTERED) --- */}
                {selectedMajor && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8 animate-fade-in">
                        {/* Dark Backdrop */}
                        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => setSelectedMajor(null)}></div>
                        
                        {/* Floating Card */}
                        <div 
                            className="bg-white w-full max-w-5xl h-[85vh] rounded-[40px] shadow-2xl relative overflow-hidden flex flex-col md:flex-row m-4 animate-scale-up z-10"
                            onClick={e => e.stopPropagation()}
                        >
                            {/* Close Button */}
                            <button className="absolute top-5 right-5 z-20 bg-white hover:bg-gray-100 p-2 rounded-full shadow-md text-gray-500 hover:text-gray-900 transition-all border border-gray-100" onClick={() => setSelectedMajor(null)}>
                                <span className="material-symbols-outlined text-2xl">close</span>
                            </button>

                            {/* LEFT SIDE: SUMMARY & ACTIONS */}
                            <div className="w-full md:w-1/3 bg-gray-50 p-8 border-r border-gray-100 flex flex-col overflow-y-auto">
                                <div className="mb-6">
                                    <span className="inline-block bg-white border border-gray-200 px-3 py-1 rounded-full text-xs font-bold text-gray-500 mb-3 shadow-sm">
                                        Chi tiết ngành
                                    </span>
                                    <h2 className="text-3xl font-black text-gray-900 leading-tight mb-3">{selectedMajor.name}</h2>
                                    <div className="flex flex-wrap gap-2">
                                        <span className="text-green-700 bg-green-100 px-3 py-1 rounded-lg text-sm font-bold border border-green-200">
                                            {selectedMajor.salary}
                                        </span>
                                        {selectedMajor.hot && <span className="text-red-600 bg-red-100 px-3 py-1 rounded-lg text-sm font-bold border border-red-200">🔥 Hot Trend</span>}
                                    </div>
                                </div>

                                <div className="space-y-4 mb-8">
                                    <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm">
                                        <p className="text-xs text-gray-400 font-bold uppercase mb-2">Khối xét tuyển</p>
                                        <div className="flex flex-wrap gap-2">
                                            {selectedMajor.subjects.map(s => <span key={s} className="bg-blue-50 text-blue-600 px-3 py-1 rounded-lg font-bold text-sm border border-blue-100">{s}</span>)}
                                        </div>
                                    </div>
                                    <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm">
                                        <p className="text-xs text-gray-400 font-bold uppercase mb-2">Kỹ năng cốt lõi</p>
                                        <div className="flex flex-wrap gap-2">
                                            {selectedMajor.skills.map(s => <span key={s} className="bg-orange-50 text-orange-600 px-3 py-1 rounded-lg font-bold text-sm border border-orange-100">{s}</span>)}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-auto pt-6 border-t border-gray-200">
                                    <button className="w-full bg-white border border-gray-200 hover:border-gray-300 text-gray-700 font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-all hover:bg-gray-50 mb-3 shadow-sm">
                                        <span className="material-symbols-outlined">share</span> Chia sẻ ngành này
                                    </button>
                                </div>
                            </div>

                            {/* RIGHT SIDE: CONTENT & MBTI */}
                            <div className="w-full md:w-2/3 p-8 overflow-y-auto bg-white custom-scrollbar">
                                
                                {/* MBTI Section */}
                                <div className="mb-8">
                                    <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                                        <span className="material-symbols-outlined text-purple-600">psychology</span>
                                        Độ phù hợp tính cách (MBTI)
                                    </h3>
                                    
                                    {userMBTI ? (
                                        <div className={`p-5 rounded-2xl border-2 flex items-start gap-4 ${checkCompatibility(selectedMajor.suitableMBTIs) === "Rất phù hợp" ? "border-green-100 bg-green-50/50" : "border-yellow-100 bg-yellow-50/50"}`}>
                                            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-xl shadow-sm font-black border border-gray-100 flex-shrink-0">
                                                {userMBTI.code}
                                            </div>
                                            <div>
                                                <p className="text-sm text-gray-500 font-medium mb-1">Kết quả của bạn: <b>{userMBTI.code}</b></p>
                                                <p className={`font-bold text-lg ${checkCompatibility(selectedMajor.suitableMBTIs) === "Rất phù hợp" ? "text-green-700" : "text-yellow-700"}`}>
                                                    {checkCompatibility(selectedMajor.suitableMBTIs)}
                                                </p>
                                                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                                                    Ngành này phù hợp nhất với nhóm: <b>{selectedMajor.suitableMBTIs.join(", ")}</b>.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="p-6 rounded-2xl border border-dashed border-gray-300 bg-gray-50 text-center">
                                            <p className="text-gray-500 mb-4 text-sm font-medium">Bạn chưa biết mình có hợp với ngành này không?</p>
                                            <button 
                                                onClick={() => navigate('/student/personality-test')}
                                                className="bg-purple-600 text-white px-6 py-2.5 rounded-full font-bold hover:bg-purple-700 transition-colors shadow-lg shadow-purple-200 text-sm"
                                            >
                                                Làm trắc nghiệm tính cách ngay ➔
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="space-y-8">
                                    <section>
                                        <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                                            <span className="material-symbols-outlined text-blue-500">description</span>
                                            Tổng quan
                                        </h3>
                                        <p className="text-gray-600 leading-relaxed text-justify bg-white border border-gray-100 p-5 rounded-2xl shadow-sm">
                                            {selectedMajor.desc} Sinh viên theo học ngành này sẽ được trang bị kiến thức nền tảng vững chắc cùng các kỹ năng thực hành để sẵn sàng gia nhập thị trường lao động sôi động.
                                        </p>
                                    </section>

                                    <section>
                                        <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                                            <span className="material-symbols-outlined text-pink-500">work_history</span>
                                            Vị trí công việc
                                        </h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                            {selectedMajor.jobs.map((job, i) => (
                                                <div key={i} className="flex items-center gap-3 p-3 bg-white border border-gray-100 rounded-xl shadow-sm hover:border-pink-200 transition-colors">
                                                    <span className="w-8 h-8 rounded-full bg-pink-50 text-pink-600 flex items-center justify-center font-bold text-sm">{i+1}</span>
                                                    <span className="font-medium text-gray-700 text-sm">{job}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* STYLES */}
            <style>{`
                :root { --primary: #DB2777; --glass-bg: rgba(255, 255, 255, 0.95); --glass-border: rgba(255, 255, 255, 1); }
                .student-page-container { width: 100%; min-height: 100vh; background: linear-gradient(135deg, #FDF2F8 0%, #EEF2FF 100%); font-family: 'Inter', sans-serif; position: relative; padding: 80px 0 0; color: #1F2937; overflow-x: hidden; }
                .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.4; z-index: 0; transform: translateZ(0); will-change: transform; }
                .blob-1 { top: -100px; left: -100px; width: 400px; height: 400px; background: #FBCFE8; }
                .blob-2 { bottom: -100px; right: -100px; width: 500px; height: 500px; background: #C4B5FD; }
                .content-wrapper { max-width: 1200px; margin: 0 auto; position: relative; z-index: 10; padding: 0 20px; }
                .student-title { font-weight: 900; color: #111827; letter-spacing: -0.02em; }
                .highlight { background: linear-gradient(90deg, #EC4899, #8B5CF6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                
                .logo-home-nav { position: fixed; top: 20px; left: 24px; z-index: 60; cursor: pointer; transition: transform 0.2s; }
                .logo-home-nav:hover { transform: scale(1.05); }
                .logo-home-nav img { height: 40px; width: auto; object-fit: contain; filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1)); }
                
                .top-nav { position: fixed; top: 90px; left: 20px; z-index: 50; }
                .back-btn-modern {
                    display: flex; align-items: center; gap: 10px;
                    background: white; padding: 8px 16px 8px 8px;
                    border-radius: 30px; border: 1px solid #E5E7EB;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
                    cursor: pointer; color: #4B5563; font-weight: 600;
                    transition: all 0.2s;
                }
                .icon-circle { width: 32px; height: 32px; background: #F3F4F6; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: background 0.2s; }
                .back-btn-modern:hover .icon-circle { background: #FCE7F3; color: var(--primary); }
                .scrollbar-hide::-webkit-scrollbar { display: none; }
                .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #E5E7EB; border-radius: 10px; }
                
                /* ANIMATIONS */
                .animate-fade-up { animation: fadeUp 0.5s ease-out; }
                .animate-fade-in { animation: fadeIn 0.2s ease-out; }
                .animate-scale-up { animation: scaleUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
                @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes scaleUp { from { opacity: 0; transform: scale(0.95) translateY(20px); } to { opacity: 1; transform: scale(1) translateY(0); } }
                
                /* MARQUEE EFFECT */
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .animate-marquee { animation: marquee 30s linear infinite; }
                .hover\:pause:hover { animation-play-state: paused; }
                .mask-gradient { mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent); }

                @media (max-width: 768px) { .back-btn-modern { top: 80px; } }
            `}</style>
        </div>
    );
}